import Vue from 'vue'

const roles = {
  state: {
    roles: [],
  },
  getters: {
    roles(state) {
      return state.roles
    },
  },
  mutations: {
    getRole(state, payload) {
      state.roles = payload
    },
  },
  actions: {
    getRole(context, payload) {
      const url = 'Role'
      Vue.prototype.$axios.get(url).then(
        (res) => {
          context.commit('getRole', res.data)
        },
        (error) => {
          console.log(error)
        }
      )
    },
    updateRole(context, payload) {
      const url = `Role/${payload.ID}`
      Vue.prototype.$axios.put(url, payload).then(
        (res) => {
          context.dispatch('getRole')
        },
        (error) => {
          console.log(error)
        }
      )
    },
    createRole(context, payload) {
      const url = `Role`
      Vue.prototype.$axios.post(url, payload).then(
        (res) => {
          context.dispatch('getRole')
        },
        (error) => {
          console.log(error)
        }
      )
    },
    deleteRole(context, payload) {
      const url = `Role/${payload.ID}`
      Vue.prototype.$axios.delete(url).then(
        (res) => {
          context.dispatch('getRole')
        },
        (error) => {
          console.log(error)
        }
      )
    },
  },
}

export default roles
